// @ts-nocheck

import React, { useEffect, useState } from "react";
import DashboardLayout from "../../components/layoutContainers/dashboardLayout";
import SoftBox from "../../components/common/softBox";
import { Card, IconButton } from "@mui/material";
import SoftTypography from "../../components/common/softTypography";
import Table from "../../components/tables/table";
import { useDispatch, useSelector } from "react-redux";
import {  getContactUs } from "../../features/contactUs";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import SoftButton from "../../components/common/softButton";
import { toast } from "react-toastify";
import { MdOutlineReplay } from "react-icons/md";
import DashboardNavbar from "../../components/navbars/dashboardNavbar";

const ContactUs = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { contacts, status } = useSelector((state: any) => state.contactUs);

  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);

 

  const columns = [
    {
      header: "ID",
      accessorKey: "id",
      id: "id",
      align: "center",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Name",
      accessorKey: "first_name",
      id: "name",
      align: "left",
      cell: (info: any) => <strong>{info.getValue()} {info.row.original.last_name}</strong>,
    },
    {
      header: "Email",
      accessorKey: "email",
      id: "email",
      align: "left",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
        header: "Mobile Number",
        accessorKey: "mobile_number",
        id: "mobile_number",
        align: "left",
        cell: (info: any) => <span>{info.getValue() || "No status available"}</span>,
      },
    {
      header: "Message",
      accessorKey: "message",
      id: "message",
      align: "left",
      cell: (info: any) => <span>{info.getValue() || "No message available"}</span>,
    },
    {
      header: "Actions",
      id: "actions",
      align: "center",
      cell: (info: any) => {
        const id = info.row.original._id;
        return (
          <div>
            <IconButton onClick={() => navigate(`/faq/edit/${id}`)}>
            <MdOutlineReplay />
            </IconButton>
       
          </div>
        );
      },
    },

   
  ];

  useEffect(() => {
    dispatch(getContactUs({ page: pageIndex, limit: pageSize }));
  }, [dispatch, pageIndex, pageSize]);

  useEffect(() => {
    if (status && contacts?.data) {
      setData(contacts.data);
      setTotalRows(contacts.pagination.total || 0);
    }
  }, [status, contacts]);

  return (
    <DashboardLayout>
            <DashboardNavbar />
      
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Card>
            <SoftBox display="flex" justifyContent="space-between" alignItems="center" pb={1} pt={3} px={3}>
              <SoftTypography variant="h4" fontWeight="bold">
                Contact Inquiries
              </SoftTypography>
       
            </SoftBox>
            <SoftBox>
              <Table
                columns={columns}
                data={data}
                pageIndex={pageIndex}
                pageSize={pageSize}
                totalRows={totalRows}
                onPageChange={(newPageIndex) => setPageIndex(newPageIndex)}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              />
            </SoftBox>
          </Card>
        </SoftBox>
      </SoftBox>
    </DashboardLayout>
  );
};

export default ContactUs;
